export default __webpack_public_path__ + "565507c3cfe6ec3b3a4f035e72d5e74c.svg";